import React, { Fragment, useState, useRef, useEffect } from "react";
import { Table, Pagination } from "react-bootstrap";

import { Link,useHistory } from "react-router-dom";
import data from "../table/tableData.js";
import Cookies from "universal-cookie";
import { getUsersTable } from '../../../apis/TableData';

const UsersTable = () => {    
    const cookies  = new Cookies();
    const token = cookies.get("token")
    const history = useHistory();
    const [tableData , setTableData] = useState()
    const [dataCount,setDataCount] = useState()
    const [fname,setFName] = useState("")
    const [lname,setLName] = useState("")
    const [username,setUsername] = useState("")
    const [email,setEmail] = useState("")
	useEffect(() => {
		if(token === null || token === undefined )
		{
			history.push("/page-login");
		}
		fetchTableData()
      
	}, [])
    const fetchTableData = () => {
        getUsersTable(token,fname,lname,username,email)
        .then(response =>
        {
            if(response.code == 200)
            {
               setTableData(response.data.data);
               setDataCount(response.data.count);
            }
        })
        .catch(error => {console.log(error)})

    }

    const resetFilter = (e) =>{
      e.preventDefault();
      getUsersTable(token,"","","","")
      .then(response =>
         {
             console.log(response)
             if(response.code == 200)
             {
                setTableData(response.data.data);
                setDataCount(response.data.count);
                setUsername("");
                setFName("");
                setLName("");
                setEmail("");
             }
         })
         .catch(error => {console.log(error)})
    };
    const queryFilter = (e) => {
      e.preventDefault();
      // console.log(avatar);
      getUsersTable(token,fname,lname,username,email)
        .then(response =>
        {
            console.log(response)
            if(response.code == 200)
            {
               setTableData(response.data.data);
               setDataCount(response.data.count);
            }
        })
        .catch(error => {console.log(error)})
   };
    
    const sort = 10;
   let jobPagination = Array(Math.ceil(data.profileTable.data.length / sort))
      .fill()
      .map((_, i) => i + 1);

   const activePag = useRef(0);
   const jobData = useRef(
      data.profileTable.data.slice(
         activePag.current * sort,
         (activePag.current + 1) * sort
      )
   );
   const [demo, setdemo] = useState();
   const onClick = (i) => {
      activePag.current = i;

      jobData.current = data.profileTable.data.slice(
         activePag.current * sort,
         (activePag.current + 1) * sort
      );
      setdemo(
         data.profileTable.data.slice(
            activePag.current * sort,
            (activePag.current + 1) * sort
         )
      );
   };
    return (
        <div className="col-12">
           <div className = "row">
           <div className="form-group col-md-3">
                      <label>First Name</label>
                      <input type="text" className="form-control" value = {fname} onChange={(e)=> setFName(e.target.value)}/>
            </div>
            <div className="form-group col-md-3">
                      <label>Last Name</label>
                      <input type="text" className="form-control" value = {lname} onChange={(e)=> setLName(e.target.value)}/>
            </div>
            <div className="form-group col-md-3">
                      <label>Username</label>
                      <input type="text" className="form-control" value = {username} onChange={(e)=> setUsername(e.target.value)}/>
            </div>
            <div className="form-group col-md-3">
                      <label>Email</label>
                      <input type="text" className="form-control" value = {email} onChange={(e)=> setEmail(e.target.value)}/>
            </div>
            {/* <div className="form-group col-md-3">
                      <label>Email</label>
                      <input type="text" className="form-control"/>
            </div> */}
           </div>
           <div className="row mb-3 d-flex justify-content-center">
              <div className = "form-group mr-2">
           <button type="submit" className="btn btn-primary" onClick={(e) => queryFilter(e)}>
                   Submit
                </button>
                </div>
                <div className = "form-group ml-2">
            <button type="reset" className="btn btn-primary" onClick={(e) => resetFilter(e)}>
                   Reset
                </button>
                </div>
           </div>
           <div className="card">
              <div className="card-header">
                 <h4 className="card-title">Profile Datatable</h4>
              </div>
              <div className="card-body">
                 <Table responsive className="w-100">
                    <div id="example_wrapper" className="dataTables_wrapper">
                       <table id="example" className="display w-100 dataTable">
                          <thead>
                             <tr role="row">
                                {/* {data.profileTable.columns.map((d, i) => (
                                   <th key={i}>{d}</th>
                                ))} */}
                                <th>Avatar</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Username</th>
                                <th>Email</th>
                                <th>Group</th>
                                <th>Active</th>

                             </tr>
                          </thead>
                          <tbody>
                             {tableData?.map((d, i) => (
                                <tr key={i}>
                                   <td><img
                                       className="rounded-circle"
                                       width="35"
                                       src={d?.avatar}
                                       alt=""
                                    /></td>
                                   <td>{d?.fname}</td>
                                   <td>{d?.lname}</td>
                                   <td><Link
                              to={"/user-profile/"+d?.id}
                           >
                              {d?.username}
                           </Link></td>
                                   <td>{d?.email}</td>
                                   <td>{d?.type}</td>
                                   <td>{d?.active}</td>
                                   {/* {d.map((da, i) => (
                                      <Fragment key={i}>
                                         <td>
                                            {i === 0 ? (
                                               <img
                                                  className="rounded-circle"
                                                  width="35"
                                                  src={da}
                                                  alt=""
                                               />
                                            ) : (
                                               <Fragment>
                                                  {da}
                                                  {i === 8 && (
                                                     <div className="d-flex">
                                                        <Link
                                                           to="#"
                                                           className="btn btn-primary shadow btn-xs sharp mr-1"
                                                        >
                                                           <i className="fa fa-pencil"></i>
                                                        </Link>
                                                        <Link
                                                           to="#"
                                                           className="btn btn-danger shadow btn-xs sharp"
                                                        >
                                                           <i className="fa fa-trash"></i>
                                                        </Link>
                                                     </div>
                                                  )}
                                               </Fragment>
                                            )}
                                         </td>
                                      </Fragment>
                                   ))} */}
                                </tr>
                             ))}
                          </tbody>
                          {/* <tfoot>
                             <tr role="row">
                                {data.profileTable.columns.map((d, i) => (
                                   <th key={i}>{d}</th>
                                ))}
                             </tr>
                          </tfoot> */}
                       </table>
  
                       <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                             Showing {activePag.current * sort + 1} to
                             {data.profileTable.data.length <
                             (activePag.current + 1) * sort
                                ? data.profileTable.data.length
                                : (activePag.current + 1) * sort}
                             of {dataCount} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                             <Pagination size="lg"
                             >
                                <li
                                   className="page-item page-indicator "
                                   onClick={() =>
                                      activePag.current > 0 &&
                                      onClick(activePag.current - 1)
                                   }
                                >
                                {/* <Link className="page-link" to="#">
                                      <i className="la la-angle-left" />
                                   </Link> */}
                                   <Link className="paginate_button previous" to="#"> Previous</Link>
                                </li>
                                {jobPagination.map((number, i) => (
                                   <Pagination.Item
                                      className={
                                         activePag.current === i ? "active" : ""
                                      }
                                      onClick={() => onClick(i)}
                                   >
                                      {number}
                                   </Pagination.Item>
                                ))}
                                <li
                                   className="page-item page-indicator"
                                   onClick={() =>
                                      activePag.current + 1 <
                                         jobPagination.length &&
                                      onClick(activePag.current + 1)
                                   }
                                >
                                  <Link className="page-link" to="#">
                                      <i className="la la-angle-right" />
                                  </Link>
                                   <Link className="paginate_button next" to="#"> Next</Link>
                                </li>
                             </Pagination>
                          </div>
                       </div>
                    </div>
                 </Table>
              </div>
           </div>
        </div>
     );
  };

export default UsersTable;
